































import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {CLICK_AND_COLLECT_ROUTES} from "@/constants/routes";
import ResendVerification from "@/views/Dialog/views/ResendVerification.vue";
import DroppoButton from "@/views/components/DroppoButton.vue";
import Dialog from "@/views/Dialog/Dialog.vue";
import {EClickCollectType} from "@/constants/orders";
import ShipmentHelperText from '@/views/components/ShipmentHelperText.vue';

const shipmentModule = namespace("shipment");

@Component({
  name: 'ClickAndCollectStart',
  components: {
    Dialog,
    ResendVerification,
    DroppoButton,
    ShipmentHelperText,
  },
})
export default class ClickAndCollectStart extends Vue {

  @shipmentModule.Action('setCCType')
  private setCCType!: (el: EClickCollectType) => void;

  private next() {
    this.$router.push({name: CLICK_AND_COLLECT_ROUTES.FORM });
  }
}
